<template>
  <div class="mx-8 pb-9">
    <div class="mb-12">
      <h5>General information</h5>
      <v-text-field
        placeholder="Title"
        v-model="ExistingManualForm.Title"
        hide-details=""
      ></v-text-field>
      <div class="error--text" v-if="$v.ExistingManualForm.Title.$error">
        Please Enter Title
      </div>
      <v-text-field
        class="mt-5"
        placeholder="Author"
        v-model="ExistingManualForm.Author"
        hide-details=""
      ></v-text-field>
      <div class="error--text" v-if="$v.ExistingManualForm.Author.$error">
        Please Enter Author Name
      </div>
    </div>
    <!-- <div class="d-flex align-center">
      <v-btn
        class="text_style mb-4 px-8"
        color="primary"
        outlined
        @click="onButtonClickThumbnail"
        >Upload Thumbnail</v-btn
      >
      <input
        ref="uploader1"
        class="d-none"
        type="file"
        accept="image/*"
        @change="onFileChangedThumbnail"
      />
      <div class="d-flex align-center ml-4" style="height: 100%">
        <v-chip
          v-if="ExistingManualForm.UploadedThumbnail"
          color="primary"
          @click:close="ExistingManualForm.UploadedThumbnail = ''"
          class="mt-n4"
          close
          outlined
          pill
          >{{ ExistingManualForm.UploadedThumbnail }}</v-chip
        >
        <p
          style="color: #8080808f"
          v-if="!ExistingManualForm.UploadedThumbnail"
        >
          (300 x 400 px)
        </p>
      </div>
    </div> -->
    <div class="d-flex justify-end mx-5 pt-8">
      <v-btn
        class="px-14 py-6 text_style"
        color="#A1A3A8"
        text
        @click="close()"
      >
        Cancel
      </v-btn>
      <v-btn color="primary" class="px-14 py-6 text_style" :disabled="btnloader" @click="send()">
        <span class="pa-4 text_style" v-if="btnloader != true"> Save </span>
        <v-progress-circular
          indeterminate
          size="20"
          v-else
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  name: "EditManualComponent",
  computed: {
    ...mapGetters(["GetLoggedInUser"]),
  },
  props: ["editItem"],
  data() {
    return {
      btnloader: false,
      UploadedfileName: "",
      thumbnailChanged: false,
      ExistingManualForm: {
        Id:null,
        Title: null,
        Author: null,
        UploadedThumbnail: "",
        Thumbnail: null,
      },
    };
  },
  watch: {
    editItem: {
      immediate: true,
      handler(EditItemUpdate) {
        if (EditItemUpdate) {
          this.ExistingManualForm.Id = EditItemUpdate.Id;
          this.ExistingManualForm.Title = EditItemUpdate.Title;
          this.ExistingManualForm.Thumbnail = EditItemUpdate.Thumbnail;
          this.ExistingManualForm.Author = EditItemUpdate.Author;

        }
      },
    },
  },
  mounted() {
    const thumbnail = this.editItem.Thumbnail.split("_")
      .slice(-1)
      .join();
      console.log("thuasmda",thumbnail);
    this.ExistingManualForm.UploadedThumbnail = thumbnail;
    this.ExistingManualForm.Title = this.editItem.Title;
    this.ExistingManualForm.Author = this.editItem.Author;
    this.ExistingManualForm.Id = this.editItem.Id;
  },
  validations: {
    ExistingManualForm: {
      Title: { required },
      Author: { required },
    },
  },
  methods: {
    onButtonClickThumbnail() {
      this.$refs.uploader1.click();
    },
    onFileChangedThumbnail(e) {
      this.thumbnailChanged = true;
      this.ExistingManualForm.Thumbnail = e.target.files[0];
      this.ExistingManualForm.UploadedThumbnail =
        this.ExistingManualForm.Thumbnail.name.substring(0, 32);
        console.log("thmubnail image",this.ExistingManualForm.UploadedThumbnail)
      this.$refs.uploader1.value = null;
    },
    close() {
      this.$emit("close");
    },
    send() {
      this.$v.$touch();
      // this.$v.form.code.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.btnloader = true;
        var form = new FormData();
        form.append("Title", this.ExistingManualForm.Title);
        form.append("Author", this.ExistingManualForm.Author);
        form.append("Id", this.ExistingManualForm.Id);
        form.append("UserId", this.GetLoggedInUser.Id);
        // if (this.thumbnailChanged) {
        //   form.append("Thumbnail", this.ExistingManualForm.Thumbnail);
        // }
        this.$store
          .dispatch("UpdateDigitalManual", form)
          .then((response) => {
            console.log("response",response);
            if(response.Status){
              this.btnloader = false;
              this.close();
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Manual edit successfully",
                showConfirmButton: false,
                timer: 2000,
              });
            }
            else{
              this.btnloader = false;
              this.close();
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: response.Message,
                showConfirmButton: false,
                timer: 5000,
              });
            }
            
          });
      }
    },
  },
};
</script>

<style></style>
